module.exports = __webpack_public_path__ + "static/media/lpt.7f1fd959.svg";